import React from 'react';
import styles from './base-page.module.sass';
import BasesList from '../../../components/BasesList/BasesList';
import { useBasesData } from '../../../hooks/useBasesData';
import { useAdminBasesActions } from '../../../hooks/useAdminBasesActions';
import { useInfiniteScroll } from '../../../hooks/useInfiniteScroll';
import Loader from '../../../components/ui/loader/loader';

const AdminBasePage = () => {
  const { data, isLoading, hasMore, fetchData, refresh } = useBasesData(true);
  const { handleSave, handleDelete } = useAdminBasesActions(refresh);
  const [initialLoadComplete, setInitialLoadComplete] = React.useState(false);

  const handleTableScroll = (progress: number) => {
    if (progress >= 0.7 && !isLoading && hasMore) {
      fetchData();
    }
  };

  const { containerRef, scrollProps } = useInfiniteScroll(
    fetchData,
    isLoading,
    hasMore,
    0.7,
  );

  React.useEffect(() => {
    if (!isLoading && data.length > 0) {
      setInitialLoadComplete(true);
    }
  }, [isLoading, data]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.innerWrapper}>
        <h2 className={styles.title}>Управление базами</h2>
      </div>

      <div ref={containerRef} {...scrollProps}>
        <BasesList
          bases={data}
          isAdmin={true}
          onSaveChanges={handleSave}
          onDelete={handleDelete}
          isLoading={isLoading}
          onScroll={handleTableScroll}
        />
      </div>

      {isLoading && initialLoadComplete && (
        <div className={styles.loaderWrapper}>
          <Loader />
        </div>
      )}
    </div>
  );
};

export default AdminBasePage;
